import React from 'react';
import classes from '../main.module.css'
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className={classes.Footer}>
            {/* Top Grid Section */}
            <div className={classes.FooterGrid}>

                {/* 1. Subscribe Column */}
                <div className={classes.FooterSubscribeCol}>
                    {/* <h2>Don't Missed Subscribed!</h2>
                    <div className={classes.SubscribeInputWrapper}>
                        <input type="email" placeholder="Enter Email" />
                        <button className={classes.SubscribeButton}>
                            <img src="/images/ic_arrow_up.svg" alt="Subscribe" />
                        </button>
                    </div> */}
                </div>

                {/* 2. Company Links Column */}
                <div className={classes.FooterLinksCol}>
                    <h3>Company</h3>
                    <ul>
                        <li><a href="#about">About Us</a></li>
                        <li><a href="#services">Our Solutions</a></li>
                        <li><a href="#case-studies">Case Studies</a></li>
                        <li><a href="#team">Our Team</a></li>
                        <li><a href="#contact">Contact Us</a></li>
                    </ul>
                </div>

                {/* 3. Solutions Links Column */}
                <div className={classes.FooterLinksCol}>
                    <h3>Our Solutions</h3>
                    <ul>
                        <li><a href="https://play.google.com/store/apps/dev?id=7333118628648613054" target='_blank' rel='noopener noreferrer'>Mobile Application</a></li>
                        <li><a href="/" style={{ cursor: 'pointer' }} onClick={(e) => e.preventDefault()}>Web Development</a></li>
                        <li><a href="/" style={{ cursor: 'pointer' }} onClick={(e) => e.preventDefault()}>UI/UX Design</a></li>
                        <li><a href="/" style={{ cursor: 'pointer' }} onClick={(e) => e.preventDefault()}>Graphic Design</a></li>
                    </ul>
                </div>
            </div>

            {/* Social Links Row */}
            <div className={classes.FooterSocialsRow}>
                <a href="https://www.linkedin.com/in/siva-8bb758230?utm_source=share_via&utm_content=profile&utm_medium=member_ios" target='_blank' rel='noopener noreferrer'><span>●</span> LinkedIn</a>
                <a href="https://wa.me/918870343924" target='_blank' rel='noopener noreferrer'><span>●</span> WhatsApp</a>
                <a href="https://twitter.com/RohitSiva8?t=njcRUvBfFtxFCcWT7E229g&s=09" target='_blank' rel='noopener noreferrer'><span>●</span> Twitter</a>
                <a href="https://www.instagram.com/her__devil__cat?igsh=MWdzeGR0ZzJqY29qbg%3D%3D" target='_blank' rel='noopener noreferrer'><span>●</span> Instagram</a>
            </div>

            {/* Bottom Contact & Copyright Bar */}
            <div className={classes.FooterBottomBar}>
                <div className={classes.FooterLogoSection}>
                    <img src="/images/feline_logo.svg" alt="Feline Logo" />
                </div>

                <div className={classes.FooterContactInfo}>
                    <div className={classes.ContactItem}>
                        <span>Phone</span>
                        <h4>+91 88703 43924</h4>
                    </div>
                </div>

                <div className={classes.FooterContactInfo}>
                    <div className={classes.ContactItem}>
                        <span>Email Now</span>
                        <h4>sivarohit60@gmail.com</h4>
                    </div>
                </div>
            </div>

            {/* Very Bottom Copyright */}
            <div className={classes.FooterCopyright}>
                <div className={classes.CopyrightLeft}>
                    <span>Copyright {new Date().getFullYear()} Feline</span>
                </div>
                <div className={classes.CopyrightRight}>
                    <Link to="/policy" target="_blank" rel="noopener noreferrer"><strong>Policy, Terms & Condition</strong></Link>
                </div>
            </div>
        </footer>
    )
}

export default Footer